
export default {
  pekerjaans: [],
  total: null,
  last: null,
  per_page: 0,
  current_page: null,
  rab: [],
  filters: [],
  pekerjaan_filter: null,
  pekerjaanTags: [],
  taxonomy: null,
  meta: {},
  pekerjaanSearchQuery: ''
}
